(ns minorodata.components.file-ingest.sheet-select
  (:require [minorodata.app.handlers :refer [dispatch]]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            [ui.button :refer [button]]
            [ui.card :refer [card]]
            [ui.fields :refer [radio-group]]
            [ui.stepper :as stepper]))


(defn render-select [{:keys [sheet-names selected-sheet set-selected-sheet]}]
  (let [names-center (js/Math.floor (/ (count sheet-names) 2))
        [first-col second-col] (split-at names-center sheet-names)]
    [:<>
     [card {:class "flex p-4 justify-around items-center min-h-[200px]"}
      [radio-group {:name            "spreadsheet"
                    :data-cy         "sheet-select__item"
                    :value           selected-sheet
                    :options         (mapv (fn [sheet] {:value sheet :text sheet})
                                           first-col)
                    :on-value-change #(set-selected-sheet %)}]

      [radio-group {:name            "select-spreadsheet"
                    :data-cy         "sheet-select__item"
                    :value           selected-sheet
                    :options         (mapv (fn [sheet] {:value sheet :text sheet})
                                           second-col)
                    :on-value-change #(set-selected-sheet %)}]]

     [stepper/stepper-footer {:class "border-t-0"}
      [button {:data-cy  "sheet-select__submit"
               :disabled (nil? selected-sheet)
               :on-click #(do (dispatch [:ingest-selected-sheet/delete])
                              (dispatch [:file-ingest.events/set-selected-sheet selected-sheet]))}
       "Proceed"]]]))


(defn sheet-selection []
  (let [ingest-file        (re-posh/subscribe [:ingest-file/pull])
        selected-sheet     (reagent/atom nil)
        set-selected-sheet #(reset! selected-sheet %)]
    (fn []
      [render-select {:sheet-names        (:ingest-file/sheet-names @ingest-file)
                      :selected-sheet     @selected-sheet
                      :set-selected-sheet set-selected-sheet}])))
